import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { MailCheck } from 'lucide-react';
import { api, ApiError } from '../lib/api';
import { Alert, Button, Field } from '../components/ui';
import { AuthLayout } from './AuthLayout';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Erro inesperado. Tente novamente.');
    } finally {
      setSubmitting(false);
    }
  }

  if (sent) {
    return (
      <AuthLayout title="Verifique seu e-mail">
        <div className="space-y-5">
          <div className="flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-4">
            <MailCheck className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" aria-hidden />
            <p className="text-sm text-emerald-900">
              Se <strong className="font-medium">{email}</strong> tiver acesso ao portal, um link
              para redefinir a senha foi enviado. O link vale por tempo limitado e só pode ser usado
              uma vez.
            </p>
          </div>

          {/* A mensagem é a mesma exista ou não o cadastro: a tela não pode
              servir para descobrir quem é fornecedor da Weloze. */}
          <p className="text-sm text-slate-600">
            Não chegou? Verifique a caixa de spam ou escreva para{' '}
            <a
              href="mailto:qualidade@weloze.com.br"
              className="font-medium text-brand-600 underline-offset-2 hover:underline"
            >
              qualidade@weloze.com.br
            </a>
            .
          </p>

          <Link to="/login">
            <Button variant="outline" className="w-full">
              Voltar ao login
            </Button>
          </Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Esqueci minha senha"
      subtitle="Informe o e-mail cadastrado e enviaremos um link para criar uma nova senha."
    >
      <form onSubmit={handleSubmit} className="space-y-4" noValidate>
        {error && <Alert>{error}</Alert>}

        <Field
          label="E-mail"
          name="email"
          type="email"
          autoComplete="username"
          required
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="voce@suaempresa.com.br"
        />

        <Button type="submit" className="w-full" size="lg" loading={submitting}>
          Enviar link
        </Button>

        <div className="pt-1 text-center">
          <Link to="/login" className="text-sm text-brand-600 underline-offset-4 hover:underline">
            Voltar ao login
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}
